/* tslint:disable */

/**
 */
export class CardExemptionForm {
    from_date?: string;
    to_date?: string;
    route_id?: number;
}
